export default __webpack_public_path__ + "static/media/eye-opened.5e1a0ba0.png";